import { createPageAnalytics } from "common/analytics";

import type {
  LearningHubTabId,
  LearningItemState,
} from "@/features/learning-hub/constants";

export const howToAnalytics = createPageAnalytics("how_to");
export const lessonAnalytics = createPageAnalytics("lesson");

/**
 * `lesson_name` for each Learning Hub lesson id, plus the two lessons that
 * are not hub rows: the "Find places" tab (a walkthrough drawn inline) and
 * Home's "Contribute info" slider.
 */
const LESSON_NAMES: Record<string, string> = {
  "find-places": "find_places",
  "contribute-info": "contribute_accessibility_information",
  "set-up-profile": "set_up_profile",
  "save-places": "save_favourite_places",
  notifications: "turn_on_notifications",
  "upload-photos": "upload_photos",
  "share-experiences": "share_experiences",
  "report-issues": "report_live_issues",
};

export function lessonName(lessonId: string): string {
  return LESSON_NAMES[lessonId] ?? lessonId;
}

/** The row's circle, in the plan's words. */
export function lessonStatus(state: LearningItemState): string {
  if (state === "completed") return "completed";
  if (state === "seen") return "in_progress";
  return "unstarted";
}

/** `how_to_type` for a hub tab. */
export function howToType(tab: LearningHubTabId): string {
  return tab === "find-places" ? "find_places" : "contribute";
}
